import React from 'react';
import { Card, Row, Col, Select, Spin } from 'antd';
import {
  CardTitleText,
  MenuItemTextColor,
} from '../../../../../../../shared/globalStyling/styledText';
import TransactionsTable from './TransactionsTable';
import {
  attributionWindowSelections,
  attributionTypeSelections,
} from '../../../../../../../../core/utils/constants/constants';

const { Option } = Select;

const campaignCardStyle = {
  backgroundColor: '#fff',
  marginTop: 10,
  marginBottom: 10,
};

const TransactionDetails = ({
  transactions = [],
  transactionsPagination = { total: 0, hasNextPage: false },
  getImpressions,
  loading = false,
  attributionWindow = 30,
  changeAttributionWindow,
  attributionMethod = 'ALL',
  changeAttributionMethod,
}) => {
  // Transactions are already transformed in the controller
  const transactionData = transactions;

  const Extra = () => (
    <Row type="flex" justify="space-between" align="middle" gutter={16}>
      <Col>
        <CardTitleText text={'Transactions'} />
      </Col>
      <Col>
        <Row type="flex" align="middle" gutter={16}>
          <Col>
            <span style={{ marginRight: 8, fontSize: 14, color: '#595959' }}>
              Attribution Window:
            </span>
            <Select
              placeholder="Please select days"
              value={attributionWindow}
              style={{ width: '150px' }}
              onChange={(val) => {
                changeAttributionWindow(val);
              }}
            >
              {attributionWindowSelections.map((option) => {
                return (
                  <Option key={option.key} value={option.key}>
                    <MenuItemTextColor text={option.name} />
                  </Option>
                );
              })}
            </Select>
          </Col>
          <Col>
            <span style={{ marginRight: 8, fontSize: 14, color: '#595959' }}>
              Attribution Method:
            </span>
            <Select
              placeholder="Attribution method"
              style={{ width: '180px' }}
              value={attributionMethod}
              onChange={(val) => {
                changeAttributionMethod(val);
              }}
            >
              {attributionTypeSelections.map((option) => {
                return (
                  <Option key={option.key} value={option.key}>
                    <MenuItemTextColor text={option.name} />
                  </Option>
                );
              })}
            </Select>
          </Col>
        </Row>
      </Col>
    </Row>
  );

  return (
    <Card
      style={campaignCardStyle}
      headStyle={{ borderWidth: '3px', height: '66px' }}
      bodyStyle={{ padding: 0 }}
      title={<Extra />}
    >
      {loading ? (
        <div
          style={{
            minHeight: '400px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size="large" tip="Loading transactions..." />
        </div>
      ) : (
        <TransactionsTable
          transactionData={transactionData}
          transactionsPagination={transactionsPagination}
          getImpressions={getImpressions}
        />
      )}
    </Card>
  );
};

export default TransactionDetails;
